exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stateArea_from_StateArea-css_20v > div p {\n    color: #2E3D73;\n    font-weight: 600;\n    font-size: 0.875em;\n}\n.stateArea_from_StateArea-css_20v > div p strong {\n    font-weight: 700;\n}\n.stateArea_from_StateArea-css_20v > div p span {\n    font-weight: 400;\n}\n.stateArea_from_StateArea-css_20v > div p em {\n    font-weight: 400;\n    font-style: normal;\n    color: #A0A3A3;\n}\r\n", ""]);

// exports
exports.locals = {
	"stateArea": "stateArea_from_StateArea-css_20v"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/components/state/StateArea.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateArea.css
// module chunks = 0